/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ActionModel from 'cio/models/action';
import TemplateModel from 'cio/models/template';
import { isVisualEditorInAppMessage } from 'cio/utils/in-app/message-config';
import { action } from '@ember/object';
import { sanitize, sanitizeWithModifier } from 'cio/utils/sanitize';
import { config } from 'cio/helpers/preview-whitelist';

interface InAppActionSignature {
  Args: {
    action: ActionModel;
    disableOverlay: boolean;
    hasContent: boolean;
    disabled: boolean;
    template: TemplateModel | null;
    hasReadOnlyPermission: boolean;
    disableFrameScrolling?: boolean;
    animateFrameLoad?: boolean;
    frameClassNames?: string;
    contentBodyModifier?: (body: HTMLElement) => HTMLElement;
  };
  Element: HTMLDivElement;
}

export default class InAppAction extends Component<InAppActionSignature> {
  @tracked fadeInPreview = false;

  get isVisualEditorInAppMessage() {
    let { template } = this.args;
    return template != null && isVisualEditorInAppMessage(template);
  }

  get template() {
    return this.args.template;
  }

  get sanitizedBody() {
    if (this.template == null) {
      return '';
    }

    let { body } = this.template;

    if (this.args.contentBodyModifier != null) {
      return sanitizeWithModifier(body, config, this.args.contentBodyModifier);
    }

    return sanitize(body, config);
  }

  @action
  onFrameLoad() {
    if (this.args.animateFrameLoad == null || !this.args.animateFrameLoad) {
      return;
    }

    this.fadeInPreview = true;
  }
}
